import { Add as AddIcon, AttachFile as AttachFileIcon, BookOnline as BookOnlineIcon } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../shared/enums/profiles";

export interface IToolbarSinisterValuesProps {
	showButtonGenerateBordero?: boolean;
	showButtonNew?: boolean;
	showButtonAttachments?: boolean;
	onClickAddNew?: () => void;
	onClickGenerateBordero?: () => void;
	onClickAttachments?: () => void;
	selectedIds?: Set<string>;
	attachmentsDisabled?: boolean;
}

export const ToolbarSinisterValues = ({
	showButtonGenerateBordero = true,
	showButtonNew = true,
	showButtonAttachments = true,
	onClickAddNew = () => {},
	onClickGenerateBordero = () => {},
	onClickAttachments = () => {},
	selectedIds = new Set<string>(),
	attachmentsDisabled = false,
}: IToolbarSinisterValuesProps) => {
	const handleOpenModalValueSinister = () => {
		onClickAddNew();
	};

	const handleOpenModalBordero = () => {
		onClickGenerateBordero();
	};

	const handleOpenModalAttachments = () => {
		onClickAttachments();
	};

	return (
		<>
			<Grid className="xdx" container item direction="row" spacing={2} style={{ marginLeft: "25px", justifyContent: "right" }}>
				{showButtonNew && checkByProfileGuard(PermissionRolesEnum.SinisterValuesOptions, PermissionActionsEnum.Add) && (
					<Grid item style={{ width: "auto", paddingLeft: 0 }}>
						<Button fullWidth color="primary" disableElevation variant={"contained"} onClick={handleOpenModalValueSinister} startIcon={<AddIcon />}>
							Adicionar
						</Button>
					</Grid>
				)}

				{showButtonGenerateBordero && checkByProfileGuard(PermissionRolesEnum.SinisterValuesOptions, PermissionActionsEnum.GenerateBordero) && (
					<Grid item style={{ paddingLeft: 0, marginLeft: "16px" }}>
						<Button
							fullWidth
							color="secondary"
							disableElevation
							variant={"contained"}
							onClick={handleOpenModalBordero}
							startIcon={<BookOnlineIcon />}
							disabled={selectedIds.size === 0}
						>
							Gerar ({selectedIds.size})
						</Button>
					</Grid>
				)}

				{showButtonAttachments && (
					<Grid item style={{ width: "auto", paddingLeft: 0, marginLeft: "16px" }}>
						<Button
							fullWidth
							color="primary"
							disableElevation
							variant={"outlined"}
							onClick={handleOpenModalAttachments}
							startIcon={<AttachFileIcon />}
							disabled={attachmentsDisabled}
						>
							Anexo(s)
						</Button>
					</Grid>
				)}
			</Grid>
		</>
	);
};
